export default __webpack_public_path__ + "static/media/howItWorksThree.98e01222.png";